import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { MatDialog, MatDialogRef } from '@angular/material';
import { ImprimeTicketComponent } from '../../imprime-ticket/imprime-ticket.component';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {MAT_MOMENT_DATE_FORMATS, MomentDateAdapter} from '@angular/material-moment-adapter';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import * as moment from 'moment';

import * as pdfMake from 'pdfmake/build/pdfmake.js';
import * as pdfFonts from 'pdfmake/build/vfs_fonts.js';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export const MY_FORMATS = {
  parse: {
    dateInput: 'L', 
  },
  display: {
    dateInput: 'L',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMM YYYY',
  },
};

@Component({
  selector: 'app-cancelaciones',
  templateUrl: './cancelaciones.component.html',
  styleUrls: ['./cancelaciones.component.css'],
  providers: [
    { provide: MatDialogRef,useValue: {} },
    {provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
    {provide: MAT_DATE_LOCALE, useValue: "es-MX" },
  ] 
})
export class CancelacionesComponent implements OnInit {
  errMsg:any;
  cancelados:any=[];
  roles:any=[];
  prods:any=[];
  descs:any=[];
  users:any=[];
  loading:boolean=false;
  fecIni:any = moment();
  fecFin:any = moment();
  usr:string="0";
  gpo:any=[];
  idGpo:number=0;
  
  thisForm = new FormGroup({
    usr: new FormControl(this.usr == "0" ? 0 : this.usr, []),
    gpo: new FormControl(this.idGpo, []),
  });

  constructor(private dataService: DataService) { }

  ngOnInit() {
    this.loading = true;
    //----->>>>>>>>>>
    this.dataService.getGrupos().subscribe(
                      rows => {   
                              this.gpo = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnGruposCargados());

    this.dataService.getUsuarios('%').subscribe(
                      rows => {   
                              this.users = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnUsuariosCargados());
  }

  fnGruposCargados(){
    //console.log(this.gpo);
  }

  fnUsuariosCargados(){
    //console.log(this.users);
    this.dataService.getDescuentos(-1).subscribe(
                      rows => {   
                              this.descs = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnDescuentosCargados());
  }

  fnDescuentosCargados(){
    //console.log(this.descs);
    this.dataService.getProductos().subscribe(
                      rows => {   
                              this.prods = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnProductosCargados());
  }

  fnProductosCargados(){
    //console.log(this.prods);
    this.dataService.cancelaciones(this.usr, '%', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo).subscribe(
                      rows => {   
                              this.cancelados = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnTicketsCanceladosCargados());
  }

  fnTicketsCanceladosCargados(){
    //console.log(this.cancelados);
    for(var i = 0; i < this.cancelados.length; i++){
      if(this.cancelados[i].idDesc > 0){
        var auxDesc = this.dataService.findItemInObject(this.descs, this.cancelados[i].idDesc, "id");
        var auxAux = "";
        try{
          auxAux = auxDesc.descuento;
        }
        catch{

        }
      }
      this.cancelados[i].aplicaDescuento = " (" + auxAux + ")";
      var auxUsr = "";
      try{
        auxUsr = this.dataService.findItemInObject(this.users, this.cancelados[i].idUsuario, "idUsuario").nombre;
      }
      catch{
        auxUsr = "?";
      }
      this.cancelados[i].usuario = auxUsr;
    }
    this.loading = false;
  }

  onChange(idEl, item, tipo){
    //console.log("onChange: " + tipo)
    this.onClick(idEl,item,tipo);
  }

  onClick(idEl, item, tipo){
    this.loading = true;
    //console.log(tipo);
    //console.log("onClick: " + idEl);
    //console.log(item);
    if(tipo=="GPO"){
      this.idGpo = idEl;
      this.thisForm.controls["gpo"].setValue(this.idGpo);
    }   

    if(tipo=="USER"){
      this.usr = idEl;
      console.log(this.usr)
      if(this.usr=='%')
        this.thisForm.controls["usr"].setValue(0);
      else
        this.thisForm.controls["usr"].setValue(this.usr);
    }   
    this.dataService.cancelaciones(this.usr, '%', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo).subscribe(
                      rows => {   
                              this.cancelados = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnTicketsCanceladosCargados());

  }

  fnCambiaFecha(tipo, obj){
    if (tipo=="INI"){
      this.fecIni = moment(obj.value.format("YYYYMMDD"));
    }
    if (tipo=="FIN"){
      this.fecFin = moment(obj.value.format("YYYYMMDD"));
    }
    this.dataService.cancelaciones(this.usr, '%', this.fecIni.format("YYYYMMDD"), this.fecFin.format("YYYYMMDD"), this.idGpo).subscribe(
                      rows => {   
                              this.cancelados = <any>rows
                              },          
                      error => this.errMsg = <any>error,
                      () => this.fnTicketsCanceladosCargados());
  }

}
